import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { isBrowser } from '../../utilities/misc';
// import MediaQuery from 'react-responsive';

import { rem } from '../../utilities/style';
import { colors } from '../../theme/colors';
import { media } from '../../theme/media';
import TableHeaderCell from './TableHeaderCell';
import TopScrollBarWrapper from './TopScrollBarWrapper';

const ResponsiveTableWrapper = styled.div`
  margin: ${rem(35)} 0;
  overflow-x: auto;
  max-width: calc(100vw - ${rem(40)});

  ${media('>smedium')} {
    max-width: calc(100vw - ${rem(80)});
  }
`;

const TableStyled = styled.table`
  position: relative;
  z-index: 0;
  width: auto;
  border-collapse: collapse;
  background: ${colors.white};

  td {
    vertical-align: middle;
  }

  tr th:first-of-type,
  tr td:first-of-type {
    text-align: left;
  }

  tbody tr:hover td {
    background: ${colors.gray['50']};
  }
`;
const Table = ({ children }) => {
  const firstGrandchildType = children.length > 0
    ? children[0]?.props?.children[0]?.type : null;
  const isFirstChildHeader = firstGrandchildType === TableHeaderCell.type;
  const [firstRow, ...rest] = children;
  const [windowWidth, setWindowWidth] = useState(575);

  useEffect(() => {
    if (isBrowser) {
      setWindowWidth(window?.visualViewport?.width);
    }
  }, [windowWidth]);

  return (
    <>
      {(isBrowser
      && window?.visualViewport?.width < 576) ? <TopScrollBarWrapper /> : null}
      <ResponsiveTableWrapper>
        <TableStyled>
          {isFirstChildHeader && (
            <thead>
              {isFirstChildHeader && firstRow}
            </thead>
          )}
          <tbody>
            {isFirstChildHeader ? rest : children}
          </tbody>
        </TableStyled>
      </ResponsiveTableWrapper>
    </>
  );
};

Table.propTypes = {
  children: PropTypes.node.isRequired
};

export default Table;
